<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-member-list',
          title: this.$t('admin_member_list.list'),
        },
        {
          name: 'admin-member-catalog',
          title: this.$t('admin_member_list.catalog'),
        },
        {
          name: 'admin-member-loginlog-list',
          title: this.$t('admin_member_list.login_log'),
        },
        {
          name: 'admin-member-account-list',
          title: this.$t('admin_member_list.account'),
        },
        {
          name: 'admin-member-oauth2-client-list',
          title: this.$t('member_nav.retained'),
        },
        {
          name: 'admin-member-invite-relation-list',
          title: this.$t('member_nav.recommended_relationship'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul
    v-if="$route.name !== 'admin-member-list'"
    :class="$style.localNavigation"
  >
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
